import Request from './request'

const SimcardProfileTraffic = {
  getSimcardProfileTraffic(params, callback) {
    Request.get('simcard-profile-traffic/index', params).then(callback).catch(this.bad_answer)
  },
}
export default SimcardProfileTraffic
